import { library } from '@fortawesome/fontawesome-svg-core'
import { faPen, faArrowsAlt, faTrash, faSlash, faDownload, faUserPlus } from '@fortawesome/free-solid-svg-icons'
import { faSquare, faCircle } from '@fortawesome/free-regular-svg-icons'

library.add(faPen, faArrowsAlt, faSquare, faCircle, faTrash, faSlash, faDownload, faUserPlus)
